import { Component, OnInit, Input } from '@angular/core';

export interface IShotsSummaryItem {
  title: string;
  value: number;
  unit: string;
  shots: {
    success: number;
    total: number;
    accuracy: number;
  };
}

@Component({
  selector: 'app-shots-summary',
  templateUrl: './shots-summary.component.html',
  styleUrls: ['./shots-summary.component.scss']
})
export class ShotsSummaryComponent implements OnInit {
  @Input() data: IShotsSummaryItem[];

  constructor() { }

  ngOnInit() {
  }

  private getAccuracyColorClass (accuracy) {
    const step = 100 / 5;
    let zone;
    if (accuracy === 0) {
      zone = 0;
    } else if (accuracy < step) {
      zone = 1;
    } else if (accuracy < step * 2) {
      zone = 2;
    } else if (accuracy < step * 3) {
      zone = 3;
    } else if (accuracy < step * 4) {
      zone = 4;
    } else {
      zone = 5;
    }
    return `acc${zone}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/stats/shots-summary/shots-summary.component.ts